"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _tradeBanner = _interopRequireDefault(require("../../components/trade/trade-banner.vue"));
var _rightNav = _interopRequireDefault(require("../../components/trade/right-nav.vue"));
var _goodsList = _interopRequireDefault(require("../../components/trade/goods-list.vue"));
var _footNav = _interopRequireDefault(require("../../components/foot-nav"));
var _askPush = _interopRequireDefault(require("../../components/trade/ask-push.vue"));
var _api = _interopRequireDefault(require("../../api/api"));
var _util = _interopRequireDefault(require("../../assets/static/js/utils/util.js"));
var _elementUi = require("element-ui");
var _cookie = require("@/assets/static/js/utils/cookie.js");
var _default = exports.default = {
  name: 'goodsdetail',
  components: {
    tradeBanner: _tradeBanner.default,
    rightNav: _rightNav.default,
    goodsList: _goodsList.default,
    askPush: _askPush.default,
    footNav: _footNav.default
  },
  data: function data() {
    return {
      userId: '',
      gsid: '',
      showPush: false,
      showPhone: false,
      joinedStart: '',
      joinedEnd: '',
      detailData: {},
      recData: [],
      rightAdverData: [],
      sortConfig: {
        sortFlag: false
      },
      shareConfig: {
        url: '',
        title: '有【货】找车',
        image: 'http://www.weihuabiaoju.com/mp/images/wximg/logo-center.jpg',
        sites: ['qq', 'wechat', 'weibo'],
        wechatQrcodeTitle: '微信扫一扫',
        wechatQrcodeHelper: '<p>请用微信扫码分享</p>'
      },
      initQCode: 'http://www.weihuabiaoju.com/appDownload.dhtml?ncrypt=()(c)L33E/NY32aX1VkUU366w==',
      tabList: [{
        name: '货源查询',
        url: 'goods'
      }, {
        name: '车源查询',
        url: 'cars'
      }, {
        name: '发布车源',
        url: 'pubcars'
      }, {
        name: '发布货源',
        url: 'pubgoods'
      }]
    };
  },
  created: function created() {
    // session替换成cookie
    var userInfo = (0, _cookie.getCookie)("user") ? JSON.parse((0, _cookie.getCookie)("user")) : '';
    // var userInfo = JSON.parse(window.sessionStorage.getItem("user"))
    this.userId = userInfo ? userInfo.usid : '';
    this.gsid = this.$route.query.gsid;
    this.loadDetailData();
    this.loadRecData();
    this.loadAdvertiseData();
    this.shareConfig.url = this.$root.baseUrl + '/app/cargo/ammShareMain.app?type=2&id=' + this.gsid + '&userId=' + this.userId;
    console.log('option:', this.gsid);
  },
  methods: {
    tabChange: function tabChange(url) {
      this.$router.push({
        name: url
      });
    },
    //获取货源详情
    loadDetailData: function () {
      var _loadDetailData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that, loadInstance, _yield$Api$apiGetGood, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = this;
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              _context.next = 4;
              return _api.default.apiGetGoodsDetailData({
                gsid: that.gsid
              });
            case 4:
              _yield$Api$apiGetGood = _context.sent;
              data = _yield$Api$apiGetGood.data;
              loadInstance.close();
              that.detailData = data.proData;
              that.joinedStart = _util.default.joinCityAndDistrict(data.proData.startProvince, data.proData.startCity, '');
              that.joinedEnd = _util.default.joinCityAndDistrict(data.proData.endProvince, data.proData.endCity, '');
              // that.shareConfig.title = '有【货】找车:' + that.detailData.startLocation + '-' + that.detailData.endLocation
              console.log('detailData:', that.detailData);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadDetailData() {
        return _loadDetailData.apply(this, arguments);
      }
      return loadDetailData;
    }(),
    //获取推荐货源
    loadRecData: function () {
      var _loadRecData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, _yield$Api$apiGetRecG, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              that = this;
              _context2.next = 3;
              return _api.default.apiGetRecGoodsBygsidData({
                gsid: that.gsid
              });
            case 3:
              _yield$Api$apiGetRecG = _context2.sent;
              data = _yield$Api$apiGetRecG.data;
              that.recData = data.proData.splice(0, 3);
              console.log('recData:', that.recData);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function loadRecData() {
        return _loadRecData.apply(this, arguments);
      }
      return loadRecData;
    }(),
    //获取广告
    loadAdvertiseData: function () {
      var _loadAdvertiseData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, _yield$Api$apiGetAdve, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              that = this;
              _context3.next = 3;
              return _api.default.apiGetAdvertiseData({
                showType: 'PC_GS_DETAIL',
                userId: that.userId ? that.userId : ''
              });
            case 3:
              _yield$Api$apiGetAdve = _context3.sent;
              data = _yield$Api$apiGetAdve.data;
              that.rightAdverData = data.proData;
              console.log('adverdata:', that.rightAdverData);
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function loadAdvertiseData() {
        return _loadAdvertiseData.apply(this, arguments);
      }
      return loadAdvertiseData;
    }(),
    // 立即报价
    clickToPush: function clickToPush() {
      // session替换成cookie
      var userStorage = (0, _cookie.getCookie)('user');
      var userToken = (0, _cookie.getCookie)('token');
      // let userStorage = window.sessionStorage.getItem('user')
      if (!userStorage || !userToken) {
        console.log('userStorage', userStorage);
        // console.log('token2',getTimeLocal('token'))
        this.$root.loginscene = 'GS_DETAIL'; //注册登录场景
        this.$root.loginsceneid = this.gsid;
        this.$root.dialogFormVisible = true;
      } else {
        this.showPush = true;
      }
      console.log('showPush:', this.showPush);
    },
    // 拨打电话
    clickToCall: function clickToCall() {
      // session替换成cookie
      // let userStorage = getCookie('user')
      // // let userStorage = window.sessionStorage.getItem('user')
      // if (!userStorage) {
      // 	this.$root.loginscene = 'GS_DETAIL' //注册登录场景
      // 	this.$root.loginsceneid = this.gsid
      // 	this.$root.dialogFormVisible = true
      // } else {
      this.showPhone = true;
      // }
      console.log('showPhone:', this.showPhone);
    }
  }
};